export default __webpack_public_path__ + "static/media/x-black.914039081a9b148ff7a07ac5436644f6.svg";